import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { IBadgeListProps, IBadgeListItem } from './types';
import {
  LastVisitorTableHeading,
  DescriptionColumn,
  DeactivateColumn,
} from './BadgeList.styled';
import { useMediaQuery } from 'beautiful-react-hooks';

const BadgeList: React.FC<IBadgeListProps> = ({
  badges,
  onDeactivate,
  onActivate,
}) => {
  const isSmall = useMediaQuery('(max-width: 48rem)');

  const renderListItem = (badge: IBadgeListItem) => (
    <tr key={badge.number}>
      <DescriptionColumn>{badge.description}</DescriptionColumn>
      {!isSmall && <td>{badge.lastVisitor?.name}</td>}
      {!isSmall && <td>{badge.lastVisitor?.company}</td>}
      {!isSmall && <td>{badge.lastVisitor?.host}</td>}
      {!isSmall && <td>{badge.lastVisitor?.dated}</td>}

      <DeactivateColumn>
        <Button
          type="button"
          className="w-100"
          variant={badge.deactivated ? 'success' : 'danger'}
          size="sm"
          onClick={() =>
            badge.deactivated
              ? onActivate(badge.number)
              : onDeactivate(badge.number)
          }
        >
          {badge.deactivated ? 'Activate' : 'Deactivate'}
        </Button>
      </DeactivateColumn>
    </tr>
  );

  return (
    <Table hover responsive>
      <thead>
        {!isSmall && (
          <tr>
            <th />
            <LastVisitorTableHeading colSpan={4} className="text-center">
              Last visitor to use badge
            </LastVisitorTableHeading>
          </tr>
        )}
        <tr>
          <th>Description</th>
          {!isSmall && <LastVisitorTableHeading>Name</LastVisitorTableHeading>}
          {!isSmall && (
            <LastVisitorTableHeading>Company</LastVisitorTableHeading>
          )}
          {!isSmall && <LastVisitorTableHeading>Host</LastVisitorTableHeading>}
          {!isSmall && <LastVisitorTableHeading>Date</LastVisitorTableHeading>}
          <th />
        </tr>
      </thead>
      <tbody>{badges.map(renderListItem)}</tbody>
    </Table>
  );
};

export default BadgeList;
